import Empty from './Empty';
export default Empty;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-empty/src/index.js